module.exports = "<div id=\"batlinechart\" style=\"height: 26vh; width: 100%;\"></div>"